import { join } from "node:path";

import { renderStateCompact } from "../kernel/compact.js";
import { loadPositionForCommand } from "../kernel/board-engine.js";
import { buildSearchReport } from "../kernel/search.js";
import { boardDirectory, compressBoardRelativePath } from "../repo/board-meta.js";
import { withBoardDatabase, writeArtifact } from "../repo/board-store.js";
import type { ExecutionContext } from "../runtime/context.js";
import { writeTextFileAtomic } from "../runtime/filesystem.js";
import type { CompactRequest } from "../cli/protocol.js";

const LATEST_STATE_ARTIFACT = "artifacts/latest-state.md";

export async function handleCompact(
  context: ExecutionContext,
  request: CompactRequest,
) {
  const { board, position } = await loadPositionForCommand(context, request.s, request.p);
  const report = buildSearchReport(board, position, 1);
  const compact = renderStateCompact(board, position, report);
  const artifactFilePath = join(boardDirectory(context, board.sessionKey), LATEST_STATE_ARTIFACT);

  await writeTextFileAtomic(artifactFilePath, compact);

  await withBoardDatabase(context, request.s, (database) =>
    writeArtifact(database, {
      content: compact,
      kind: "compact.state",
      relativePath: LATEST_STATE_ARTIFACT,
    }),
  );

  return {
    artifactPath: compressBoardRelativePath(board, LATEST_STATE_ARTIFACT),
    compact,
    mode: request.m,
    report,
  };
}
